<template>
    <div id="chartcontainer" >
        <div class='chartwrapper' v-for="chart in charts" v-bind:key="chart.tmpkey || chart.key" >

            <v-card class="resultschart" :style="'min-height: '+(chart.options.height + 54)+'px'" :id="chart.key" v-if="hidekeys.indexOf(chart.key) < 0">
                <v-card-text >
                    <div v-if="mergedConfig.showConfig && editchart===chart.key" class="charteditor">
                        <v-row justify="space-between">
                            <div class='cardtitle'>Edit this chart</div>
                            <v-btn v-if="mergedConfig.showConfig"  outlined small @click="editchart=false">View Chart</v-btn>
                        </v-row>
                        <v-row  justify="space-between">
                            <v-text-field name="charttitle" :value="chart.title" label="Chart Title" @change="saveChart($event, 'title', chart)" />
                        </v-row>
                        <v-row  justify="space-between">
                            <v-select :items="graphtypesavailable" label="Graph Type" :value="chart.showtype || chart.type" @input="saveChart($event, 'type', chart)" />
                        </v-row>
                        <v-row  justify="space-between">
                            <v-text-field name="vAxisTitle" :value="chart.options.vAxis.title" label="Vertical Axis Title (Default is &quot;'Response time in ms&quot;" @change="saveChart($event, 'vAxisTitle', chart)" />
                        </v-row>
                        <v-row  justify="space-between">
                            <h4 class="col-md-12">Fields</h4>
                            <v-row  justify="space-between" class="fieldrows">
                                <div class="col-md-6">
                                    <v-checkbox  label="Result Time (rt)" value="rt" v-model="chart.showfields" @click.stop="saveChartFields(!$event, 'rt', 'show', chart)" ></v-checkbox>
                                </div>
                                <div class="col-md-6" v-if="chart.fields && chart.fields.rt">
                                    <v-text-field label="Label" name="label" :value="(chart.fields.rt && chart.fields.rt.label) || 'Response Time'" @change="saveChartFields($event, 'rt', 'label', chart)" class="fieldinput"/>
                                </div>
                            </v-row>
                            <v-row justify="space-between" class="fieldrows" v-for="(field, idx) in reports_checkstatus.reportCheck.fields" v-bind:key="'configchartfields-' + idx">
                                <div class="col-md-6">
                                    <v-checkbox  :label="field.name" :input-value="!!(chart.fields && chart.fields.f && chart.fields.f[idx])" value @click.stop="saveChartFields(!field.show, idx, 'show', chart)" class="fieldinput"></v-checkbox>
                                </div>
                                <div class="col-md-6" v-if="chart.fields && chart.fields.f && chart.fields.f[idx]">
                                    <v-text-field label="Label" name="label" :value="(chart.fields && chart.fields.f && chart.fields.f[idx] && chart.fields.f[idx].label) || field.name.split('.').pop()" @change="saveChartFields($event, idx, 'label', chart)" class="fieldinput"/>
                                </div>
                            </v-row>
                        </v-row>

                        <v-row  justify="space-between">
                            <div v-if="removeconfirm">
                                <p>Please confirm the removal of this chart.  There is no undelete.</p>
                                <v-btn color="secondary" class="elevation-1" dark small @click="removeconfirm = false">
                                    Cancel
                                    <v-icon dark right>{{ 'cancel' | icon }}</v-icon>
                                </v-btn>
                                <v-btn color="warning" class="elevation-1 ml-1" dark small @click="removeChart(chart)" >
                                    Remove Chart
                                    <v-icon dark right>{{ 'remove' | icon }}</v-icon>
                                </v-btn>
                            </div>
                            <v-btn color="warning" class="elevation-1 ml-1" dark small @click="removeconfirm=true" v-else>
                                Remove Chart
                                <v-icon dark right>{{ 'remove' | icon }}</v-icon>
                            </v-btn>
                        </v-row>

                        <code v-if="showchartconfig && showConfig" @click="showchartconfig=!showchartconfig">{{chart}}</code>
                        <code v-if="!showchartconfig" @click="showchartconfig=!showchartconfig">Show config</code>
                    </div>
                    <div v-else class="showingchart" >
                        <v-row justify="space-between" class="resultshead">
                            <div class="cardtitle">{{ chart.title }}</div>
                            <v-btn v-if="mergedConfig.showConfig && showConfig" outlined small @click="editchart=chart.key;removeconfirm = false">Edit</v-btn>
                        </v-row>
                        <!-- <code>{{chart}}</code> -->
                        <GChart :type="chart.type" :data="chartResults(chart)"  :options="chart.options" :settings="chart.settings" :resizeDebounce="500" />
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <div v-if="showConfig">
            <v-card class="resultschart" :style="'min-height: 100px'">
                <v-card-text >
                    <v-btn outlined small @click="addChart()">Add Another Chart</v-btn>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import appconfig from "../config/shared";
import { mapState, mapGetters } from "vuex";
import { GChart } from 'vue-google-charts';
import reportSchema from "../config/reports_checkstatus";

import _size from "lodash/size";
import _cloneDeep from "lodash/cloneDeep";
import { parse as date_parse, format as date_format } from "date-fns";
import { filterHTML } from '../lib/filter';

export default {
    name: "ReportsResultsChart",
    components: { GChart },
    props: {
        resultsSet: {
            type: Number,
            default: 0
        },
        showConfig: { type: Boolean }
    },
    data () {
        return {
            // chartOptions: null,
            editchart: false,
            removeconfirm: false,
            hidekeys: [],
            graphtypesavailable: [
                {text: "Line Graph", value: "LineChart" },
                {text: "Area Graph", value: "AreaChart" },
                {text: "Stacked Area Graph", value: "StackedAreaChart" },
                {text: "Gauge", value: "Gauge"}
            ],
            showchartconfig: false,
        }
    },
    computed: {
        ...mapState(["currentUser", "reports_checkstatus", "now"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]),
        charts: function () {
            let list = Object.assign({}, this.mergedConfig.resultscharts);
            // console.log('chart list from config', list);
            if(_size(list) < 1 ){
                // list = {default: {options:{}}};
                list = {};
                let key = Date.now().toString(36);
                list[key] = {options:{}};
            }

            // list.two = {
            //     type: "AreaChart",
            //     title: "Disk Free",
            //     fields: {
            //         f: {
            //             'FMC4C7': {label: "Disk Free Data"},
            //             'FMN7K7': {label: "Disk Free /"}
            //         }
            //     }
            // };

            let typeDefaults = reportSchema[this.reports_checkstatus.reportCheck.type] || {};

            // console.log('chart list with default', list);
            for(let k in list){
                list[k].options = list[k].options || {};
                list[k].key = k;
                list[k].showfields = [];

                for(let prop in reportSchema.default){
                    if(prop === "options"){
                        for(let opt in reportSchema.default.options){
                            if(list[k].options[opt] === undefined) list[k].options[opt] = reportSchema.default.options[opt];
                        }
                    } else {
                        if(!list[k][prop]) list[k][prop] = _cloneDeep(typeDefaults[prop] || reportSchema.default[prop]);
                    }
                    if(prop === "fields"){
                        // list[k][prop].f
                        for(let idx in list[k][prop]){
                            if(idx === "f"){
                                if(list[k][prop].f === true){
                                    list[k][prop].f = {};
                                    for(let fidx in this.reports_checkstatus.reportCheck.fields){
                                        let label = this.reports_checkstatus.reportCheck.fields[fidx].name;
                                        if(label.indexOf('.') > -1) label = label.split('.').pop();
                                        list[k].showfields.push(fidx);
                                        list[k][prop].f[fidx] = {label: label};
                                    }
                                } else {
                                    for(let fidx in list[k][prop].f){
                                        list[k].showfields.push(fidx);
                                    }
                                }
                            } else {
                                list[k].showfields.push(idx);
                            }
                        }
                    }
                    list[k].settings = (list[k].type === "Gauge") ? { packages: ['corechart', 'gauge'] } : undefined ;
                }
                if(list[k].type === "StackedAreaChart" || (list[k].options && list[k].options.isStacked)){
                    // console.log('setting StackedAreaChart options', k)
                    list[k].showtype = "StackedAreaChart";
                    list[k].type = "AreaChart";
                    list[k].options = list[k].options || {};
                    list[k].options.isStacked = true;
                    list[k].options.focusTarget = 'category';
                }

                switch(this.$vuetify.breakpoint.name){
                    case "sm":
                    case "xs":
                        list[k].options.width = this.$vuetify.breakpoint.width * 0.8;
                        // list[k].options.width = 280;
                        // list[k].options.chartArea.width = "80%";
                        if(list[k].options && list[k].options.vAxis && list[k].options.vAxis.title) delete list[k].options.vAxis.title;
                        break;
                    case "md":
                        list[k].options.width = this.$vuetify.breakpoint.width * 0.83;
                        break;
                    default:
                        list[k].options.width = this.$vuetify.breakpoint.width * 0.667;
                }
                // list[k].options.width = list[k].options.width * .8;


                // if(list[k] && list[k].options && list[k].options.chart){
                //     for(let n in list[k].options.chart){
                //         list[k].options[n] = list[k].options.chart[n];
                //     }
                //     delete list[k].options.chart;
                // }
            }
            // console.log('chart list returning', list);
            // console.log('breakpoint', this.$vuetify.breakpoint);
            return list;
        }
    },
    methods: {
        chartResults: function (chart) {
            // console.log('chartResults for', chart);

            let data;
            if(chart.labels && chart.labels.length){
                data =[ chart.labels.slice(0)];
            } else {
                data =[ ["Time"] ];
            }

            // console.log('chartResults header row', data);

            if(chart.labels.length < 2){
                for(let idx in chart.fields){
                    if(idx === "f" && chart.fields[idx] === true){
                        for(let f in this.reports_checkstatus.reportCheck.fields){
                            let label = this.reports_checkstatus.reportCheck.fields[f].name;
                            if(label.indexOf('.') > -1) label = label.split('.').pop();
                            data[0].push(label);
                        }
                    } else if(idx === "f"){
                        // console.log("Looks like we have an extended field set.", idx, chart.fields[idx]);
                        for(let fidx in chart.fields.f){
                            // console.log("adding field label for", fidx);
                            if(chart.fields[idx][fidx] === true || !chart.fields[idx][fidx] || !chart.fields[idx][fidx].label){
                                data[0].push(fidx);
                            } else {
                                let label = chart.fields.f[fidx].label;
                                if(!label){
                                    label = (this.reports_checkstatus.reportCheck.fields[fidx] && this.reports_checkstatus.reportCheck.fields[fidx].name) || fidx;
                                    if(label.indexOf('.') > -1) label = label.split('.').pop();
                                }
                                data[0].push(label);
                            }
                        }

                    } else if(chart.fields[idx].label){
                        data[0].push(chart.fields[idx].label);
                    }
                }
            }
            let dlength = (this.reports_checkstatus.reportResults && this.reports_checkstatus.reportResults.length);
            for(let i=0; i < dlength; i++ ){
                data[i+1] = [
                    date_parse(this.reports_checkstatus.reportResults[i].s),
                ];
                for(let k in chart.fields){
                    if(k === "f" && chart.fields[k] === true){
                        // console.log("f", this.reports_checkstatus.reportResults[i].f);
                        for(let f in this.reports_checkstatus.reportResults[i].f){
                            data[i+1].push(this.reports_checkstatus.reportResults[i].f[f] - 0);
                        }
                    } else if(k === "f"){
                        for(let fidx in chart.fields.f){
                            data[i+1].push(this.reports_checkstatus.reportResults[i].f[fidx] - 0 );
                        }
                    } else {
                        data[i+1].push(this.reports_checkstatus.reportResults[i][k] - 0)
                    }
                }
                if(chart.type === "Gauge" && i >= 3) break;

                // @TODO handle StackedAreaChart here.  Type and settings need adjusting.
            }

            return data;
        },
        saveChart: function (value, field, chartconfig){
            // console.log('saveChart', field, chartconfig.key)

            let out = {  };
            if(this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.resultscharts){
                out.resultscharts = this.reports_checkstatus.reportConfig.check.resultscharts
            } else {
                out.resultscharts = this.charts;
            }

            if(field === "REMOVE"){
                if(out.resultscharts[chartconfig.key]){
                    delete out.resultscharts[chartconfig.key];
                } else {
                    return;
                }
            } else {
                out.resultscharts[chartconfig.key] = out.resultscharts[chartconfig.key] || { key: chartconfig.key };

                if(field === "vAxisTitle"){
                    out.resultscharts[chartconfig.key].options = out.resultscharts[chartconfig.key].options || {};
                    out.resultscharts[chartconfig.key].options.vAxis = { title: filterHTML(value, 'strip')};
                } else if(field === "type" && value === "StackedAreaChart"){
                        out.resultscharts[chartconfig.key].showtype = "StackedAreaChart";
                        out.resultscharts[chartconfig.key].type = "AreaChart";
                        out.resultscharts[chartconfig.key].options = out.resultscharts[chartconfig.key].options || {};
                        out.resultscharts[chartconfig.key].options.isStacked = true;
                } else if(field === "type"){
                    out.resultscharts[chartconfig.key][field] = value;
                    if(out.resultscharts[chartconfig.key].showtype) delete out.resultscharts[chartconfig.key].showtype;
                    if(out.resultscharts[chartconfig.key].options && out.resultscharts[chartconfig.key].options.isStacked) delete out.resultscharts[chartconfig.key].options.isStacked
                } else if(field === "title"){
                    out.resultscharts[chartconfig.key][field] = filterHTML(value, 'strip');
                } else {
                    out.resultscharts[chartconfig.key][field] = value;
                }

                out.resultscharts[chartconfig.key].tmpkey = out.resultscharts[chartconfig.key].key + Date.now().toString(36);
            }
            // console.log('saveChart will save', out);

            return this.$store.dispatch('reports_checkstatus/setReportCheckConfig', out)
                .then( (result) => {
                    // console.log('saveCheckConfig returned from setReportCheckConfig', field, result)
                    // if(field === "uptimespan"){
                    //     this.$store.dispatch('reports_checkstatus/getUptime', { reportid: this.reportid });
                    // }
                    if(field === "fields" || field === "REMOVE" || chartconfig.forceupdate ){
                        // console.log('updated chart, forcing update');
                        this.$forceUpdate();
                    }
                })
                .catch( (e) => {
                    console.log('saveCheckConfig ERROR', e);
                });

        },
        saveChartFields: function(evt, fieldidx, field, chartconfig){
            // console.log('saveChartFields', fieldidx, field, chartconfig.key);

            let fields = chartconfig.fields || {};
            fields.f = fields.f || {};
            if(field === "show"){
                // console.log('setting show for field field', fieldidx, fields.f[fieldidx]);
                if(fieldidx === "rt"){
                    if(fields.rt){
                        delete fields.rt
                    } else {
                        let label = (this.reports_checkstatus.reportCheck.fields[fieldidx] && this.reports_checkstatus.reportCheck.fields[fieldidx].name) || fieldidx;
                        if(label.indexOf('.') > -1) label = label.split('.').pop();
                        fields.rt = {label: label};
                    }
                } else {
                    if(fields.f[fieldidx]){
                        // it is there already, so we're removing.
                        delete fields.f[fieldidx];
                    } else {
                        let label = (this.reports_checkstatus.reportCheck.fields && this.reports_checkstatus.reportCheck.fields[fieldidx] && this.reports_checkstatus.reportCheck.fields[fieldidx].name) || fieldidx;
                        if(label.indexOf('.') > -1) label = label.split('.').pop();
                        fields.f[fieldidx] = {
                            label: label,
                            show: true
                        };
                    }
                }
            } else if (field === "label"){
                if(fieldidx === "rt"){
                    fields.rt = fields.rt || {};
                    fields.rt.label = filterHTML(evt, 'strip');
                } else if(!fields.f[fieldidx]){
                    console.log("Error: You cannot add a label to a field that is not being charted.");
                    return false;
                } else {
                    fields.f[fieldidx].label = filterHTML(evt, 'strip');
                }
            }
            // console.log('ready to save chart fields', fields);
            return this.saveChart(fields, 'fields', chartconfig);
        },
        addChart: function () {
            return this.saveChart('LineChart', 'type', {key: Date.now().toString(36), forceupdate: true});
        },
        removeChart: function(chart) {
            this.editchart = false;
            this.hidekeys = chart.key;
            this.saveChart('REMOVE', 'REMOVE', chart);
        }
        // setChartConfig: function () {
        //     this.chartOptions = Object.assign({}, reportSchema.default.options);
        //     // console.log("setChartConfig", this.reports_checkstatus.reportCheck);
        //     if(
        //         this.reports_checkstatus && this.reports_checkstatus.reportCheck && this.reports_checkstatus.reportCheck.type &&
        //         reportSchema[this.reports_checkstatus.reportCheck.type]
        //     ){
        //         for(let key in reportSchema[this.reports_checkstatus.reportCheck.type].options){
        //             if(typeof reportSchema[this.reports_checkstatus.reportCheck.type].options[key] === "object"){
        //                 this.chartOptions[key] = Object.assign({}, this.chartOptions[key], reportSchema[this.reports_checkstatus.reportCheck.type].options[key]);
        //                 console.log("setting option", key, reportSchema[this.reports_checkstatus.reportCheck.type].options[key], this.chartOptions[key])
        //             } else {
        //                 this.chartOptions[key] = reportSchema[this.reports_checkstatus.reportCheck.type].options[key];
        //             }
        //         }
        //     }
        //     console.log("setChartConfig", this.chartOptions);
        // }
    },
    created () {
        // this.setChartConfig();
    },
    filters: {
        icon: function ( val ) {
            return appconfig.icons[val] || val;
        }
    }
}
</script>

<style scoped>
    .chartwrapper {
        padding-bottom: 12px;
    }
    .charttitle {
        display: block;
        font-size: 1.5em;
        margin-block-start: 0.83em;
        margin-block-end: 0.83em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }
    .charteditor {
        padding: 1em;
    }
    .resultshead {
        padding-left: 1em;
        padding-right: 1em;
    }
    .fieldrows {
        width: 100%;
        padding: 0 0 0 12px;
    }
    .fieldinput {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-top:0;
    }
</style>
